'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * Nummerierte Schritt-Liste. item: { number, title, description? }.
 */
export function StepListBlock({ background, eyebrow, headline, intro, items = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <FadeIn>
          <div className="max-w-4xl mx-auto mb-12 text-center">
            {eyebrow && (
              <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2">
                {eyebrow}
              </p>
            )}
            {headline && (
              <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-4 text-gray-900 dark:text-gray-100">
                {headline}
              </h2>
            )}
            {intro && <p className="text-lg text-gray-700 dark:text-gray-300">{intro}</p>}
          </div>
        </FadeIn>
        <div className="max-w-3xl mx-auto space-y-6">
          {items.map((step, i) => (
            <FadeIn key={i} delay={i * 0.08}>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm border border-gray-100 dark:border-gray-700 border-l-4 border-l-accent dark:border-l-accent flex items-start gap-5">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-accent text-white rounded-full flex items-center justify-center font-heading font-bold text-lg">
                    {step.number}
                  </div>
                </div>
                <div>
                  <div className="font-heading font-bold text-lg text-gray-900 dark:text-gray-100">
                    {step.title}
                  </div>
                  {step.description && (
                    <p className="text-gray-700 dark:text-gray-300 text-sm mt-1">{step.description}</p>
                  )}
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
